import { ComponentClass } from 'react';
export { ComponentClass };

import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';
import HeaderPaneProps from './components/HeaderPaneProps';

import './orchestrators/openPremiumDashboard';
import './orchestrators/showHelpPane';
import './orchestrators/showQuickOptions';
import './orchestrators/tryTodoPanelOrchestrator';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "HeaderPane", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded components
export const DiagnosticsPane = createLazyComponent(lazyModule, m => m.DiagnosticsPane);
export const FeatureFlagsPane = createLazyComponent(lazyModule, m => m.FeatureFlagsPane);
export const FeatureFlagsHeader = createLazyComponent(lazyModule, m => m.FeatureFlagsHeader);
export const FeatureFlagsList = createLazyComponent(lazyModule, m => m.FeatureFlagsList);
export const HelpPane = createLazyComponent(lazyModule, m => m.HelpPane);
export const MeCardPane = createLazyComponent(lazyModule, m => m.MeCardPane);
export const SettingsPane = createLazyComponent(lazyModule, m => m.SettingsPane);
export const FeedbackPane = createLazyComponent(lazyModule, m => m.FeedbackPane);
export const WafflePane = createLazyComponent(lazyModule, m => m.WafflePane);
export const GetStartedPane = createLazyComponent(lazyModule, m => m.GetStartedPane);
export const WhatsNewPane = createLazyComponent(lazyModule, m => m.WhatsNewPane);
export const TodoPane = createLazyComponent(lazyModule, m => m.TodoPane);
export const TimePanelPane = createLazyComponent(lazyModule, m => m.TimePanelPane);
export const MiniMavenPane = createLazyComponent(lazyModule, m => m.MiniMavenPane);
export const ActivityFeedPane = createLazyComponent(lazyModule, m => m.ActivityFeedPane);
export const LazyLaunchHelpPane = new LazyAction(lazyModule, m => m.launchHelpPane);
export const LazyShowTodoPanelWithSubject = new LazyAction(
    lazyModule,
    m => m.showTodoPanelWithSubject
);
export { HeaderPaneProps };
export const LazyLaunchGetStartedOwaFlexPane = new LazyAction(
    lazyModule,
    m => m.toggleGetStartedPane
);
